import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getQuestionnaire = createAsyncThunk(
  "questionnaire/getQuestionnaire",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/investor/getQuestionnaire?groupId=QGI1000001`
      );
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addUserQuestion = createAsyncThunk(
  "questionnaire/addUserQuestion",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/investor/addUserQuestion`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const OnboardingSlice = createSlice({
  name: "questionnaire",
  initialState: {
    questionsData: {},
    loading: false,
    error: null,
    qtnSubmitLoading: false,
    qtnSubmitError: null,
  },

  extraReducers: (builder) => {
    builder.addCase(getQuestionnaire.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getQuestionnaire.fulfilled, (state, action) => {
      state.loading = false;
      state.questionsData = action.payload;
      state.error = null;
    });
    builder.addCase(getQuestionnaire.rejected, (state, action) => {
      state.loading = false;
      state.questionsData = {};
      state.error = action.payload;
    });

    builder.addCase(addUserQuestion.pending, (state) => {
      state.qtnSubmitLoading = true;
      state.qtnSubmitError = null;
    });
    builder.addCase(addUserQuestion.fulfilled, (state, action) => {
      state.qtnSubmitLoading = false;
      state.qtnSubmitError = null;
    });
    builder.addCase(addUserQuestion.rejected, (state, action) => {
      state.qtnSubmitLoading = false;
      state.qtnSubmitError = action.payload;
    });
  },
  reducers: {},
});

// eslint-disable-next-line no-empty-pattern
export const {} = OnboardingSlice.actions;

export default OnboardingSlice.reducer;
